import {Base} from "@/api/Base"

export class SalaryGetPreSalaryOtherList extends Base {
    path = "salary/getPreSalaryOtherList"
}